import React, { useState, useEffect, lazy } from "react";

const PaginationBase = lazy(() =>
  import("@mbo/pagination").then((module) => ({
    default: module.Pagination,
  })),
);

const Pagination = (props) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => setLoaded(true), []);

  if (!loaded) return null;
  return <PaginationBase {...props} />;
};

export default Pagination;
